export default "__VITE_ASSET__CORGq6gC__"